import { LogOut } from 'lucide-react';
import posthog from 'posthog-js';
import { useState } from 'react';

import { ConfirmDialog, TextButton } from '../../shared/ui';
import { useAppDispatch } from '../../hooks/redux';
import { logout } from '../../store/auth.slice';

/** Выход из аккаунта. Серверного logout нет — токены удаляются только в этом браузере. */
export const LogoutButton = () => {
  const dispatch = useAppDispatch();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const onConfirm = () => {
    dispatch(logout());
    posthog.reset();
    // Полная перезагрузка, а не navigate: в кэшах RTK Query остаются данные клиентов этого психолога.
    window.location.assign('/');
  };

  return (
    <>
      <TextButton
        tone="muted"
        className="text-ui"
        startIcon={<LogOut size={16} aria-hidden />}
        onClick={() => setIsConfirmOpen(true)}
      >
        Выйти из аккаунта
      </TextButton>
      <ConfirmDialog
        isOpen={isConfirmOpen}
        title="Выйти из аккаунта?"
        message="Чтобы вернуться, понадобится снова войти по коду из письма."
        confirmText="Выйти"
        cancelText="Остаться"
        sheetOnMobile
        onConfirm={onConfirm}
        onCancel={() => setIsConfirmOpen(false)}
      />
    </>
  );
};
